import axios from "@axios";
import store from "@/store";
import {useUtils as useI18nUtils} from "@core/libs/i18n";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(master_account => ({
        id: master_account.id,
        name: master_account.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async export({commit}, params) {
      try {
        // First make the export request with sorting parameters
        const queryParams = new URLSearchParams({
          action: 'export',
          sortBy: params.sortBy || 'id',
          sortDesc: params.sortDesc || true
        }).toString();

        const response = await axios.get(`v1/ntechlab_master_account?${queryParams}`, {
          responseType: "blob"
        });

        if (!response.data) {
          throw new Error('No data received');
        }

        // Create and trigger download
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();

        // Create notification
        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "Luna master account",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: "Reporte de Luna master account",
          body: "Descarga completa",
          error: false,
          timestamp: new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };

        // Update notification in store
        store.dispatch("grid/updateDownloadNotification", notification);

        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async getAll({commit}, params) {
      const {data} = await axios.get('v1/ntechlab_master_account', {params})

      if (!data.success) {
        return []
      }
      commit('setData', data.data)
      return data
    },
    async add(_, params) {
      const {data} = await axios.post('v1/ntechlab_master_account', params)

      return data
    },
    async edit(_, {id, params}) {
      const {data} = await axios.put(`v1/ntechlab_master_account/${id}`, params)

      return data
    },
    async delete(_, id) {
      const {data} = await axios.delete(`v1/ntechlab_master_account/${id}`)

      return data
    },
    async syncData(_, params) {
      const {data} = await axios.post('v1/ntechlab_master_account/sync-data-from-ntechlab', params)

      return data
    },
    clear({commit}) {
      commit('setData', [])
    }
  },
}
